import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('circle', { cx: '16', cy: '23.36', r: '2.24' }),
  React.createElement('circle', { cx: '16', cy: '16', r: '2.24' }),
  React.createElement('circle', { cx: '16', cy: '8.64', r: '2.24' })
), {
  viewBox: '0 0 32 32'
});